import { selectComponentState } from 'projectRedux/store';
import { eppComponentAdapter } from '../adapters/eppComponentAdapter';

export const {
  selectAll: selectAllEppComponents,
  selectById: selectEppComponentById,
  selectEntities: selectEppComponentEntities,
} = eppComponentAdapter.getSelectors((state) => selectComponentState(state).eppComponents);
